<template>
  <div class="field-tooltip">
    <div class="col-1 pl-0 text-right no-global-click"
    v-if="fieldData.help_text && fieldData.help_text != ''"
    @click="clickToolTip('tooltip_'+fieldData.field_name)">
      <icon name="info-circle" scale="1.2" class="no-global-click"></icon>
    </div>

    <div :id="'tooltip_'+fieldData.field_name" class="popTip col-md-4 col-lg-6 small col-flush-viewport-left hide-tooltip-click" v-if="fieldData.help_text && fieldData.help_text != ''" :ref="'tooltip_'+fieldData.field_name" style="display: none">
      <div class="form-row">
        <div class="col-1 mt-4 px-0">
          <div class="arrowLeft float-right"></div>
        </div>
        <div class="col p-3 bg-light rounded" v-html="fieldData.help_text"></div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  props: ["fieldData"],
  methods: {
    // TODO: Needs refactor. Possibly use Bootstrap tooltip.
    clickToolTip(domElement) {
      event.stopPropagation();

      var slides = document.getElementsByClassName("hide-tooltip-click");
      for (var i = 0; i < slides.length; i++) {
        if (slides.item(i).id != domElement) {
          slides.item(i).style.display = "none";
        }
      }
      this.$refs[domElement].style.display == "block" // Errors if tooltip element doesn't exist
        ? (this.$refs[domElement].style.display = "none")
        : (this.$refs[domElement].style.display = "block");
    }
  }
};
</script>

<style scoped>
.popTip {
  position: absolute;
  right: 0;
}

.no-global-click {
  color: #adadad;
}

.arrowLeft {
  width: 0;
  height: 0;
  border-top: 12px solid transparent;
  border-bottom: 12px solid transparent;
  border-right: 12px solid #eeeeee;
}
</style>



// WEBPACK FOOTER //
// src/components/presentational/FieldTooltip.vue?390260c5